// extracted by mini-css-extract-plugin
export var chefTitle = "style-mod--chef-title--0a760";
export var learnMore = "style-mod--learn-more--1d495";
export var lmFigure = "style-mod--lm-figure--fc419";
export var lmText = "style-mod--lm-text--6f512";
export var nextIcon = "style-mod--next-icon--46a85";
export var pcCard = "style-mod--pc-card--fe8f3";
export var pcCardBody = "style-mod--pc-card-body--cb881";
export var pcCardBodyContent = "style-mod--pc-card-body-content--3a177";
export var pcCardImg = "style-mod--pc-card-img--84d97";
export var pcImg = "style-mod--pc-img--1fa99";
export var pcTitle = "style-mod--pc-title--8aea7";
export var position = "style-mod--position--65958";
export var prevIcon = "style-mod--prev-icon--d95c9";
export var professionalChefs = "style-mod--professional-chefs--9ab8d";
export var sliderArrows = "style-mod--slider-arrows--9e62b";
export var titlePosition = "style-mod--title-position--71b91";